import React from 'react';

// functions
import { decimalOrBust } from '../../utilities/currency';
import { resize } from '../../services/cloudinaryService';


function selectAndFormatRange(range = '', name = '') {
  const retVal = range || name;
  return retVal[0] ? `${retVal[0].toUpperCase()}${retVal.slice(1).toLowerCase()}` : '';
}

function selectAndFormatDescription(webDescription = '') {
  return webDescription || '';
}

function selectAndFormatSwatch(swatchColour = '') {
  return swatchColour ? `in ${swatchColour.toLowerCase()}` : '';
}

function formatPrice(price) {
  return `£${decimalOrBust(price)}`;
}

function VirtualPackageBasketItem({ items, discount }) {
  const referenceItem = items[0];
  const totalBundlePrice = items.reduce((acc, item) => acc + item.totalPrice.value, 0);

  return [
    <div
      key={`virtual-package-header${referenceItem.swkUniqueToken}`}
      className="u-padding-y-small u-padding-left-small basket__item__description"
    >
      <div className="basket__item__range">{selectAndFormatRange(referenceItem.range, referenceItem.name)} bundle</div>
      <div className="basket__item__swatch"><small>{selectAndFormatSwatch(referenceItem.swatchColour)}, {items.length} items</small></div>
    </div>,
    items.map((item, i) => (
      <li
        key={`package-item-${item.swkUniqueToken}-${item.entryNumber}`}
        className={i + 1 !== items.length ? 'no-border' : 'u-padding-bottom-small'}
      >
        <div
          className="basket__bundle-item u-padding-top-small u-padding-bottom-small"
        >
          <div className="image-wrap">
            <img src={resize(item.product.scoopImage)} alt={''} />
            {item.quantity > 1 ? (
              <span className="quantity">
                x{item.quantity}
              </span>
            ) : null
            }
          </div>

          <div className="description u-padding-left-small">
            <div className="range">{selectAndFormatRange(item.product.range, item.product.name)}</div>
            <div className="web-description">{selectAndFormatDescription(item.product.webDescription)}</div>
            <div className="swatch">{selectAndFormatSwatch(item.product.swatchColour)}</div>
          </div>
        </div>

      </li>
    )
    ),
    (
      <li
        key={`virtual-package-prices${referenceItem.swkUniqueToken}`}
      >
        <div
          className="basket__item basket__item__bundle-total u-padding-top-small u-padding-bottom-small u-padding-right-small"
        >
          <div className="description ">
            <div className="range u-text-nowrap">Bundle total</div>
          </div>
        </div>

        <div className="basket__value u-padding-small u-padding-top-medium">
          <div>{formatPrice(totalBundlePrice - discount.value)}</div>
          {
            <div><strike>{formatPrice(totalBundlePrice)}</strike></div>
          }
        </div>
      </li>
    )
  ];
}

export default VirtualPackageBasketItem;



// WEBPACK FOOTER //
// ./src/parts/HybrisBasket/VirtualPackageBasketItem.js